import { OpportunitiesTab } from '@/features/sales/OpportunitiesTab';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/sales/opportunities')({
  validateSearch: z.object({
    channel: z.string().optional(),
    assignee: z.string().optional(),
    q: z.string().optional(),
  }),
  component: OpportunitiesTab,
});
